import { useCallback, useState } from 'react';
import type { ReactNode, VFC } from 'react';

import classNames from 'classnames';

import { Image } from '../Image/Image';
import type { ImageSources } from '../../helpers/images';
import { ProgressBar } from '../Asset/shared/ProgressBar/ProgressBar';

import * as styles from './Thumbnail.module.scss';

export interface ThumbnailProps {
  imageSources?: ImageSources;
  className?: string;
  children?: ReactNode;
  isRounded?: boolean;
  progress?: number;
  variant?:
    | 'gradient-top'
    | 'gradient-bottom'
    | 'gradient-both'
    | 'none'
    | 'fill';
}

export const Thumbnail: VFC<ThumbnailProps> = ({
  imageSources,
  className,
  children,
  isRounded,
  progress,
  variant = 'none',
}) => {
  const [isReady, setIsReady] = useState(false);

  const onLoad = useCallback(() => {
    setIsReady(true);
  }, []);

  return (
    <div
      className={classNames(className, styles.thumbnail, {
        [styles.isLoaded]: isReady,
      })}
    >
      <Image
        imageSources={imageSources}
        onLoad={onLoad}
        isRounded={isRounded}
      />
      {['gradient-top', 'gradient-both'].includes(variant) && (
        <div className={styles.gradientTop} />
      )}
      {['gradient-bottom', 'gradient-both'].includes(variant) && (
        <div className={styles.gradientBottom} />
      )}
      {variant === 'fill' && <div className={styles.fill} />}
      <div
        className={classNames(styles.overlay, {
          [styles.progressBar]: Boolean(progress),
        })}
      >
        {children}
      </div>
      <ProgressBar value={progress} />
    </div>
  );
};
